/*
  Should Match the FeatureEnum Backend Code:
  https://github.com/shipstation/shipstation/blob/master/SS.Business/AccountProfile/Enumerations.cs#L3
*/

// These are for user and shipment limits. They are not technically features but are used in a similar way.
export const ADD_USER = 'add_user';
export const ShipmentVolume = 'ShipmentVolume';

export const AddressValidation = 'AddressValidation';
export const AutoSplit = 'AutoSplit';
export const AutoBatching = 'AutoBatching';
export const BarcodeScanning = 'BarcodeScanning';
export const BrandedDomains = 'BrandedDomains';
export const BrandedReturnsExchangePortal = 'BrandedReturnsExchangePortal';
export const BrandedTracking = 'BrandedTracking';
export const ChatSupportBasic = 'ChatSupportBasic';
export const CombineSplitOrdersShipments = 'CombineSplitOrdersShipments';
export const CommonAutomationRules = 'CommonAutomationRules';
export const Cubiscan = 'Cubiscan';
export const DashboardsViewOnly = 'DashboardsViewOnly';
export const DataExport = 'DataExport';
export const DedicatedAccountManager = 'DedicatedAccountManager';
export const DemoOrders = 'DemoOrders';
export const DiscountedCarrierRates = 'DiscountedCarrierRates';
export const DropShip = 'DropShip';
export const EmailCommunityForumHelpLibrary = 'EmailCommunityForumHelpLibrary';
export const EmailSupport = 'EmailSupport';
export const EnhancedReturns = 'EnhancedReturnsByReturnRabbit';
export const FreemiumRateShopper = 'FreemiumRateShopper';
export const FulfillmentProviderBundle = 'FulfillmentProviderBundle';
export const GoogleIntegration = 'GoogleIntegration';
export const GoogleSSO = 'GoogleSSO';
export const HotKeys = 'HotKeys';
export const InsurancePurchase = 'InsurancePurchase';
export const InventoryApi = 'InventoryApi';
export const InventoryManagementBasic = 'InventoryManagementBasic';
export const InventoryReordering = 'InventoryReordering';
export const InventoryReceiving = 'InventoryReceiving';
export const InventorySync = 'InventorySync';
export const LegacyBrandedReturns = 'LegacyBrandedReturns';
export const LegacyReturnLabels = 'LegacyReturnLabels';
export const LossPrevention = 'LossPrevention';
export const LotTracking = 'LotTracking';
export const MailChimpIntegration = 'MailChimpIntegration';
export const ManualOrderCreation = 'ManualOrderCreation';
export const MerchantManagedReturnsPortal = 'MerchantManagedReturnsPortal';
export const NonWalletProviderAccess = 'NonWalletProviderAccess';
export const ODBC = 'ODBC';
export const OrderImportBasic = 'OrderImportBasic';
export const OrderImportCustomStore = 'OrderImportCustomStore';
export const OrderRouting = 'OrderRouting';
export const OtherIntegrations = 'OtherIntegrations';
export const PackingSlips = 'PackingSlips';
export const PickLists = 'PickLists';
export const PickListsCustomized = 'PickListsCustomized';
export const WarehouseMobileBasicPicking = 'WarehouseMobileBasicPicking';
export const WarehouseMobileTotePicking = 'WarehouseMobileTotePicking';
export const PackingSlipsCustomized = 'PackingSlipsCustomized';
export const PhoneSupport = 'PhoneSupport';
export const ProductBundles = 'ProductBundles';
export const ProductCatalog = 'ProductCatalog';
export const PurchaseAdditionalUsers = 'PurchaseAdditionalUsers';
export const QuickbooksIntegration = 'QuickbooksIntegration';
export const ReportsDownload = 'ReportsDownload';
export const ReportsViewOnly = 'ReportsViewOnly';
export const ShipStationApiV2 = 'ShipStationApiV2';
export const ShipStationFulfillmentWhiteLabel = 'ShipStationFulfillmentWhitelabel';
export const ShippingStrategies = 'ShippingStrategies';
export const SmartFill = 'ShipAI'; // ShipAI is the original feature name that still exists in the backend code and dbo.Features table
export const SmartRouting = 'SmartRouting';
export const TrackingCustomerNotificationEmails = 'TrackingCustomerNotificationEmails';
export const UnlimitedAutomationRules = 'UnlimitedAutomationRules';
export const ExternalStoresAccess = 'ExternalStoresAccess';
export const UserRoleManagementFeature = 'UserRoleManagementFeature';
export const WebhooksIntegration = 'WebhooksIntegration';
export const ZapierIntegration = 'ZapierIntegration';
export const ShipStationAnalytics = 'ShipStationAnalytics';
export const PremiumAnalytics = 'PremiumAnalytics';
export const RefundAssist = 'RefundAssist';
export const ReorderAssist = 'ReorderAssist';
export const PurchaseOrders = 'PurchaseOrders';
export const ScanToReceive = 'ScanToReceive';
export const MobilePicking = 'MobilePicking';
export const PickingStatuses = 'PickingStatuses';
export const PickToTote = 'PickToTote';
export const AIAutomationRuleCreator = 'AIAutomationRuleCreator';
export const AiShippyAssistant = 'AiShippyAssistant';
export const AiHarmonizationCodeGenerator = 'AiHarmonizationCodeGenerator';
export const OrderDetailsCustomLayout = 'OrderDetailsCustomLayout';

/** @typedef {import('./features-type').FeatureCode} FeatureCode */

/**
 * @type {Record<FeatureCode, FeatureCode>}
 */
export const Features = {
  AddressValidation,
  AutoSplit,
  AutoBatching,
  BarcodeScanning,
  BrandedDomains,
  BrandedReturnsExchangePortal,
  BrandedTracking,
  ChatSupportBasic,
  CombineSplitOrdersShipments,
  CommonAutomationRules,
  Cubiscan,
  DashboardsViewOnly,
  DataExport,
  DedicatedAccountManager,
  DemoOrders,
  DiscountedCarrierRates,
  DropShip,
  EmailCommunityForumHelpLibrary,
  EmailSupport,
  EnhancedReturns,
  FreemiumRateShopper,
  FulfillmentProviderBundle,
  GoogleIntegration,
  GoogleSSO,
  HotKeys,
  InsurancePurchase,
  InventoryApi,
  InventoryManagementBasic,
  InventoryReordering,
  InventoryReceiving,
  InventorySync,
  LegacyBrandedReturns,
  LegacyReturnLabels,
  LossPrevention,
  LotTracking,
  MailChimpIntegration,
  ManualOrderCreation,
  MerchantManagedReturnsPortal,
  NonWalletProviderAccess,
  ODBC,
  OrderImportBasic,
  OrderImportCustomStore,
  OrderRouting,
  OtherIntegrations,
  PackingSlips,
  PackingSlipsCustomized,
  PickLists,
  PickListsCustomized,
  WarehouseMobileBasicPicking,
  WarehouseMobileTotePicking,
  PhoneSupport,
  ProductBundles,
  ProductCatalog,
  PurchaseAdditionalUsers,
  QuickbooksIntegration,
  ReportsDownload,
  ReportsViewOnly,
  ShipStationApiV2,
  ShipStationFulfillmentWhitelabel: ShipStationFulfillmentWhiteLabel,
  ShippingStrategies,
  SmartFill,
  SmartRouting,
  TrackingCustomerNotificationEmails,
  UnlimitedAutomationRules,
  ExternalStoresAccess,
  UserRoleManagementFeature,
  WebhooksIntegration,
  ZapierIntegration,
  ShipStationAnalytics,
  PremiumAnalytics,
  RefundAssist,
  ReorderAssist,
  PurchaseOrders,
  ScanToReceive,
  MobilePicking,
  PickingStatuses,
  PickToTote,
  AIAutomationRuleCreator,
  AiShippyAssistant,
  AiHarmonizationCodeGenerator,
  OrderDetailsCustomLayout,
};
